import React from "react";
import { FormattedMessage as FM } from "react-intl";

import { InfoIcon } from "components/Icons";

// Diccionario de mensajes y estilos según el estado
const stateConfig = {
  draft: {
    message: "sale.state.draft.message",
    bg: "bg-red-100",
    text: "text-red-900",
  },
  processing: {
    message: "sale.state.processing.message",
    bg: "bg-yellow-200",
    text: "text-yellow-900",
  },
  succeeded: {
    message: "sale.state.succeeded.message",
    bg: "bg-green-100",
    text: "text-green-900",
  },
  
  failded: {
    message: "sale.state.failded.message",
    bg: "bg-red-200",
    text: "text-white",
  },
};

function InfoState({ state, handleClose, customMessage = null }) {
    console.log("[InfoState] state:", state, "customMessage:", customMessage);
    
  const { bg,message, text } = stateConfig[state] || {
    message: "Estado desconocido.",
    bg: "bg-gray-200",
    text: "text-gray-900",
  };

  return (
    <div
      className={`overflow-hidden text-xl content-center rounded-2xl p-10 space-y-3 ${bg}`}
    >
      <div className="flex space-x-3 items-center">
        <span>
          <InfoIcon className={`size-8 fill-current ${text}`} />
        </span>
        <h2 className={`block font-semibold text-4xl ${text}`}><FM id={`sale.state.${state}`} /></h2>
      </div>
      {customMessage && <p className="text-red-800 underline font-bold">{customMessage}</p>}
      <p className="text-gray-800"><FM id={message} /></p>
      {handleClose && (
        <button
          className={`underline text-xs ${text}`}
          onClick={() => handleClose(false)}
         
        >
          CERRAR
        </button>
      )}
    </div>
  );
}

export default InfoState;
